export default {
  WALLETTOPUP: "वॉलेट टॉपअप",
  TOPUP: "टॉपअप",
};
